import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=185d30be&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185d30be')) {
      api.createRecord('185d30be', component.options)
    } else {
      api.reload('185d30be', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=185d30be&", function () {
      api.rerender('185d30be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/CurrentYear.vue"
export default component.exports